import { OrganisatieModule } from './OrganisatieModule';
import { leidTweedeKleurAf, leesbareTekstkleur } from './kleuren';
import { initialenVan, merktekenDataUri } from './merkteken';

/**
 * Zet titel, favicon en kleuren naar die van de organisatie waarin je werkt.
 * Op het hoofddomein (geen organisatie) blijft de standaardhuisstijl staan.
 *
 * Wordt één keer bij het opstarten aangeroepen, zodat het geldt voor élke pagina:
 * beheer, deelnemers én wedstrijdleiders.
 */
export function pasOrganisatieHuisstijlToe() {
    return OrganisatieModule.huidige()
        .then(data => {
            const organisatie = data && data.success ? data.value : null;

            if (!organisatie) {
                return null;
            }

            if (organisatie.weergavenaam || organisatie.naam) {
                document.title = organisatie.weergavenaam || organisatie.naam;
            }

            zetFavicon(iconVoorOrganisatie(organisatie));

            zetKleuren(organisatie.accentKleur, organisatie.tweedeKleur);

            return organisatie;
        })
        .catch(() => null /* huisstijl is bijzaak: bij een fout blijft de standaard staan */);
}

/**
 * Het icoon voor de browsertab. Alleen het vierkante icoon komt in aanmerking: een
 * breed logo in een tab wordt een onleesbare streep. Heeft de organisatie er geen,
 * dan tekenen we een merkteken met haar initialen — hetzelfde teken dat de menubalk
 * en het inlogscherm dan tonen, zodat de tab en de pagina niet uit elkaar lopen.
 */
/**
 * Het merk voor op papier: het vierkante icoon, niet het brede logo.
 *
 * Dat lijkt de verkeerde keuze — een liggend logo staat mooier in een kop — maar het
 * logo is gekozen om op het donkere laken te liggen. Dat van Kiwanis heeft inkt met
 * een gemiddelde helderheid van 201 van de 255: op wit papier valt het weg. Het
 * icoon zit op 113 en is het enige merk dat de app al op wit zet, namelijk midden in
 * de QR-code. Zolang een organisatie maar één logo kan uploaden is dit de kant waar
 * je fout op moet gaan.
 */
export function merkVoorPrint(organisatie) {
    return iconVoorOrganisatie(organisatie || {});
}

function iconVoorOrganisatie(organisatie) {
    if (organisatie.iconPath) {
        return '/Images/' + organisatie.iconPath;
    }

    const achtergrond = organisatie.accentKleur || '#cf9a34';

    return merktekenDataUri(
        initialenVan(organisatie.weergavenaam || organisatie.naam),
        achtergrond,
        leesbareTekstkleur(achtergrond));
}

/**
 * Vult de kleurtokens. Zonder accentkleur verandert er niets — dan blijft het
 * kaartrood met goud uit tokens.css staan.
 */
export function zetKleuren(accentKleur, tweedeKleur) {
    if (!accentKleur) {
        return;
    }

    const wortel = document.documentElement;
    const tweede = tweedeKleur || leidTweedeKleurAf(accentKleur);

    wortel.style.setProperty('--accent', accentKleur);
    wortel.style.setProperty('--accent-inkt', leesbareTekstkleur(accentKleur));

    if (tweede) {
        wortel.style.setProperty('--accent-2', tweede);
        wortel.style.setProperty('--accent-2-inkt', leesbareTekstkleur(tweede));
    }
}

function zetFavicon(url) {
    // Alle bestaande icoon-verwijzingen weg. Er bij zetten is niet genoeg: browsers
    // geven voorrang aan het SVG-icoon uit index.html, ongeacht de volgorde.
    document.querySelectorAll("link[rel~='icon']").forEach(element => element.remove());

    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = url.toLowerCase().endsWith('.svg') ? 'image/svg+xml' : 'image/png';
    link.href = url;
    document.head.appendChild(link);
}
